import { IAppState } from '../../../AppModulesWrapper';

import { EMoneySource } from '../../types/reducers/user';

// Счёт размещения для подачи объявления, может отличаться от счёта размещения в настройках пользователя
export function selectPlacingMoneySource(state: IAppState): EMoneySource | null {
  return state.servicePickerWidget.publishTerms.moneySource || null;
}
